import React, { Component } from 'react';
import FAQQuestion from '../../src/models/FAQQuestion';
import FAQWidgetView from '../../src/views/components/FAQWidgetView';

type AppProps = {
  question: FAQQuestion,
}

export default class App extends Component<AppProps> {
  public render() {
    return (<FAQWidgetView question={this.props.question} id={"faqWidget_" + this.props.question.id} />);
  }
}